import { render, staticRenderFns } from "./MessageTemplatesHeader.vue?vue&type=template&id=1ea436e0&"
import script from "./MessageTemplatesHeader.vue?vue&type=script&lang=js&"
export * from "./MessageTemplatesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports